// Common constants and utilities used by the application.
import { getStoredLanguage } from 'Services/i18n';

const ESET_HELP_URL = 'https://help.eset.com';
const ESET_LEGAL_URL = 'https://go.eset.com';
const ESET_HELP_COMMAND = 'getHelp';
const ESET_HELP_NAVIGATE_PRODUCT = 'ei_navigate';
const ESET_HELP_DEPLOY_PRODUCT = 'ei_deploy';
const ESET_HELP_CLOUD = 'ei_cloud';
const ESET_HELP_LANG_ID = '1033';

const VERSION = `${window.serverInfo.versionInfo.major}.${window.serverInfo.versionInfo.minor}`;
const IS_CLOUD = window.serverInfo.useCentralRedirector;

function createTopic(topic) {
    return topic !== undefined ? `&topic=${topic}` : '';
}

function createAnchor(helpAnchor) {
    return helpAnchor !== undefined ? `#${helpAnchor}` : '';
}

function createOnPremHelpLink(product, topic, helpAnchor) {
    return `${ESET_HELP_URL}/${ESET_HELP_COMMAND}?product=${product}&version=${VERSION}&lang=${ESET_HELP_LANG_ID}${createTopic(
        topic
    )}${createAnchor(helpAnchor)}`;
}

function createEsetCloudHelpLink(topic, helpAnchor) {
    return `${ESET_HELP_URL}/${ESET_HELP_COMMAND}?product=${ESET_HELP_CLOUD}&lang=${ESET_HELP_LANG_ID}${createTopic(
        topic
    )}${createAnchor(helpAnchor)}`;
}

function createEsetHelpLink(topic, deployment = false, helpAnchor) {
    return IS_CLOUD
        ? createEsetCloudHelpLink(topic, helpAnchor)
        : createOnPremHelpLink(deployment ? ESET_HELP_DEPLOY_PRODUCT : ESET_HELP_NAVIGATE_PRODUCT, topic, helpAnchor);
}

function createEsetRulesGuideLink() {
    return IS_CLOUD ? createEsetCloudHelpLink('rules_guide') : createOnPremHelpLink('ei_rules');
}

function createEsetLegalLink(subpage) {
    let product = IS_CLOUD ? 'ei_cloud' : 'ei_on-prem';
    let version_attr = IS_CLOUD ? '' : `&version=${VERSION}`;
    let lang_attr = `&lang=${getStoredLanguage()}`;
    return `${ESET_LEGAL_URL}/${subpage}_business?product=${product}${version_attr}${lang_attr}`;
}

function createTermsOfUseLink() {
    return createEsetLegalLink('terms');
}

function createPrivacyPolicyLink() {
    return createEsetLegalLink('privacy_policy');
}

function createProtectTransitionKBLink() {
    const languageCodeConvert = (lang) => {
        switch (
            lang // from supported languages, page is only translated to ukrainian and chinese
        ) {
            case 'uk-UA':
                return 'ua';
            case 'zh-CN':
                return 'cn';
            default:
                return 'en';
        }
    };
    return `https://support-eol.eset.com/${languageCodeConvert(getStoredLanguage())}/transition_protect.html`;
}

export {
    createEsetHelpLink,
    createEsetRulesGuideLink,
    createEsetCloudHelpLink,
    createTermsOfUseLink,
    createPrivacyPolicyLink,
    createProtectTransitionKBLink,
};
